
import i18n from '@/i18n';
import {WALL_TYPES} from '@/constants';

const WALLS_FIELDS_LOOKUP = {
    [WALL_TYPES.WALL]: [
        {
            name: 'width',
            label: i18n.t('Width'),
            append: 'm'
        },
        {
            name: 'height',
            label: i18n.t('Height'),
            append: 'm'
        },
        {
            name: 'area',
            label: i18n.t('Area'),
            append: 'm<sup>2</sup>',
            readonly: true,
        },
    ],
    [WALL_TYPES.GROUND]: [
        {
            name: 'width',
            label: i18n.t('Width'),
            append: 'm'
        },
        {
            name: 'length',
            label: i18n.t('Length'),
            append: 'm'
        }
    ],
    [WALL_TYPES.CEILING]: [
        {
            name: 'width',
            label: i18n.t('Width'),
            append: 'm'
        },
        {
            name: 'length',
            label: i18n.t('Length'),
            append: 'm'
        }
    ],
    [WALL_TYPES.PIER]: [
        {
            name: 'height',
            label: i18n.t('Height'),
            append: 'm'
        },
        {
            name: 'width',
            label: i18n.t('Width'),
            append: 'm'
        },
        {
            name: 'length',
            label: i18n.t('Length'),
            append: 'm'
        }
    ],
    [WALL_TYPES.ROUND_PIER]: [
        {
            name: 'height',
            label: i18n.t('Height'),
            append: 'm'
        },
        {
            name: 'diameter',
            label: i18n.t('Diameter'),
            append: 'm'
        },
    ],
    [WALL_TYPES.TRAPEZOID]: [
        {
            name: 'a',
            label: i18n.t('Short edge'),
            append: 'm'
        },
        {
            name: 'b',
            label: i18n.t('Long edge'),
            append: 'm'
        },
        {
            name: 'c',
            label: i18n.t('Trapezoid leg 1'),
            append: 'm'
        },
        {
            name: 'd',
            label: i18n.t('Trapezoid leg 2'),
            append: 'm'
        },
        {
            name: 'h',
            label: i18n.t('Height'),
            append: 'm'
        },
    ],
}

export default WALLS_FIELDS_LOOKUP;
